<template src="./reactGrid.template.html"></template>
<script type="text/javascript">
    import moment from "moment-timezone"
    import accounting from "accounting";
    import reactGrid from "./reactGridAndList_Reservations.js"
    import unassignResGrid from "./unassignedResInChart.js"
    import { BryntumScheduler } from '@bryntum/scheduler-vue';
    import { Scheduler, ResourceTimeRanges, Override, DomClassList } from '@bryntum/scheduler';
    // import { schedulerConfig } from './dataConfig.js';
    import getDataConfig from "./getDataConfig.js";

    // Use it until https://github.com/bryntum/support/issues/4922 is fixed
    class ResourceTimeRangesOverride {
        static get target() {
            return {
                class: ResourceTimeRanges,
                product: 'scheduler',
                minVersion: '5.6.1',
                maxVersion: '6.1.0'
            }
        }

        // Provides renderer for ResourceTimeRanges
        onEventDataGenerated(renderData) {
            const { eventRecord } = renderData;

            // Calls node_modules/@bryntum/schedulerpro/source/lib/Scheduler/feature/base/ResourceTimeRangesBase.js::onEventDataGenerated
            this._overridden.onEventDataGenerated.call(this, renderData);

            // Calls node_modules/@bryntum/schedulerpro/source/lib/Scheduler/feature/ResourceTimeRanges.js::shouldInclude
            // If true, eventRecord is a ResourceTimeRange
            if (this.shouldInclude(eventRecord)) {
                // Remove text
                delete renderData.eventContent.text;

                // Add html
                var unassignedDiv = '';
                if (eventRecord.unassignedResCount != '') {
                    unassignedDiv = 'reservation-unassignedCount';
                }
                var resPriceClass = eventRecord.cls.contains('RateOR') ? 'reservation-price-RateOR' : 'reservation-price';
                var unassignedPriceClass = eventRecord.cls.contains('RateOR') ? 'reservation-price-RateOR' : 'unassigned-reservation-price';
                renderData.eventContent.html = `
                <div class="reservation">
                ${eventRecord.unassignedResCount && eventRecord.unassignedResCount > 0 ? `<div class="${unassignedDiv}">${eventRecord.unassignedResCount}</div>` : ``}
                <div class="${eventRecord.unassignedResCount && eventRecord.unassignedResCount > 0 ? unassignedPriceClass : resPriceClass}">${eventRecord.name}</div>
                <div class="reservation-minNight">${eventRecord.minNight}</div>
                </div>
            `;
            }
        }
    }

    Override.apply(ResourceTimeRangesOverride);

    export default {
        name: "reactGridComponent",
        props: {
            // result2: {
            // required: true,
            // twoWay: true
            // },
        },
        components: {
            // "vue-select": require("./vue-select.js")
            BryntumScheduler
        },
        data() {
            let ratePlanList = [];
            return {
                resAvailbleList: [],
                searchByUnits: false,
                clientType: null,
                dateRangeFilterObj: {
                    unitIdList: '',
                    propertyIdList: '',
                    unitClassIds: ''
                },
                searchObj: {},
                unitSummaryObj: {},
                selectedStartDate: null,
                selectedEndDate: null,
                availableUnitsList: [],
                numberOfPersons: 2,
                unassignAvailUnits: [],
                latestResponseDirection: 'past',
                dateRequestType: '',
                recursiveCallCounter: 0,
                filterTooltipAction: true,
                visibleStartDate: null,
                schedulerStartDate: null,
                schedulerEndDate: null,
                scrollStartDate: null,
                scrollEndDate: null,
                initialStartDate: null,
                initialEndDate: null,
                unassignStartDate: null,
                unassignEndDate: null,
                unassign_InitialStartDate: null,
                unassign_InitialEndDate: null,
                unassignScrollStartDate: null,
                unassignScrollEndDate: null,
                pageNo: 1,
                itemsPerPage: 20,
                verticalInfiniteScroll: false,
                infiniteScrollDirection: '',
                schedulerConfig: null,
                unassignedUnitEvents: [],
                ShowBryntumCalendar: localStorage.getItem('ShowBryntumCalendar') == "true" ? true : false,
                myValue: '1',
                myOptions: [{ id: "value1", issue: "123" }, { id: "value2", issue: "123" }],
                entitlements: {},
                reactGridInstance: null,
                filterSearchPropertyText: null,
                propertyList: [],
                selectedFilterColumn: null,
                filterObj: {
                    Properties: [],
                    unitList: [],
                    UnitClasses: [],
                    UnitTypes: [],
                    AmenitiesList: [],
                    Beds: null,
                    Bedrooms: null,
                    Bathrooms: null,
                    startDate: null,
                    endDate: null,
                    propertyId: "-99",
                    UnitClassId: "-99"
                },
                ratePlanId: null,
                unitClassList: [],
                currResObj: {},
                showResGrid: "#",
                isModalVisible: false,
                reactUnassignedGridInstance: null,
                popupResObj: null,
                isLoading: true,
                isPartialLoading: false,
                clouseOutGrid: false,
                rateGrid: false,
                restrictionsGrid: false,
                ratePlanList: ratePlanList,
                searchTag: '',
                openSearchPanel: false,
                openUnitSummaryPanel: false,
                toggleFilterPanel: false,
                panelFilterObj: null,
                previousDateFilter: null,
                previousRateplanFilter: null,
                scrlBtns: false,
                scrllCount: 50,
                Showmonthselector: false,
                betaStartDate: moment().format("MMMM YYYY"),
                ajax: {
                    url: window.location.protocol + '//' + window.location.hostname + (window.location.port ? ":1339" : '') + '/getRates',
                    // window.location.protocol + '//' + window.location.hostname + (window.location.port ? ":1339" : '')
                    // port:
                    type: 'POST',
                    data: function (params) {
                        var query = {
                            Tagtext: params.term,
                            SearchText: '',
                            StatusId: 1,
                            type: 'public',
                            systemParams: {
                                'Source': 'Web',
                                'SourceId': window.location.hostname,
                                'token': window.localStorage.getItem('rttoken'),
                            }
                        }

                        // Query parameters will be ?search=[term]&type=public
                        return query;
                    },
                    // success: function (response) {
                    // },
                    // error: function (d) {
                    // },
                    processResults: function (data) {
                        // Tranforms the top-level key of the response object from 'items' to 'results'
                        console.log("data,", data)

                        return {
                            ratePlanList: data[1],
                            results: data[1]
                        };
                    }
                },
                currentUnitObj: {},
                unitSummaryObj : {},
                filteredGroupSummary:[],
                resourceRecordObj:{},
                isFilteredApplied: false,
                //On scroll horizontally the month name and year is not updating correctly in the above date picker component
                visibleMonthYear: moment().format("MMMM YYYY"),
            };
        },
        methods: {
            formatFromNightlyCharges(amount) {
                let currency = accounting.formatMoney(amount, {
                    symbol: "$",
                    format: {
                    pos: "%s %v",
                    neg: "%s (%v)",
                    zero: "%s  %v",
                    },
                    thousand: ",",
                    precision: 0,
                    decimal: ".",
                });
                return currency;
            }, 
            searchAvailabilityCallback(noOfPersons) {
                var vm = this;
                vm.numberOfPersons = noOfPersons;
                let nooffPersonsvalcls = document.getElementById("brynumberOfPersonsId")
                nooffPersonsvalcls.innerHTML = vm.numberOfPersons
                vm.getAvailableUnitList();
            },
            unitSummaryPanelCallBack() {
               var vm = this; 
            },
            closeSearchPanel(value) {
                var vm = this;
                vm.openSearchPanel = value;
            },
            closeUnitSummaryPanel(value) {
                var vm = this;
                vm.openUnitSummaryPanel = value;
            },
            datePanelCallback(){
                setTimeout(() => {
                    // alert("Date clicked")
                    this.applyFilter() 
                }, 500);    
            },
            updateFilterCalendarStartDate(key, dateObj, objectPassedToParent) {
                if (this.ShowBryntumCalendar) {
                    if (dateObj) {
                        console.log("dateObj == ", dateObj)
                        this.betaStartDate = dateObj.format("MMMM YYYY");
                        this.filterObj.startDate = moment(this.betaStartDate).format("DD MMM YYYY")
                        this.filterObj.endDate = moment(this.betaStartDate).add(90, 'days').format("DD MMM YYYY")
                        // this.applyFilter()
                    }
                    this.Showmonthselector = false
                } else {
                    this.filterObj.startDate = moment().add(-2,'days').format("DD MMM YYYY");
                    this.filterObj.endDate = moment().add(90, 'days').format("DD MMM YYYY");
                }
            },
            getUniqueEventsList(events) {
                const eventsList = events.reduce((event, current) => {
                    const isDuplicate = event.some(item => item.Reservationid == current.Reservationid && item.resourceId == current.resourceId);
                    if (!isDuplicate) {
                        return [...event, current];
                    }
                    return event;
                }, []);
                console.log("eventsList", eventsList)
                return eventsList;
            },
            toggleCalendar() {
                let vm = this;
                vm.ShowBryntumCalendar = !vm.ShowBryntumCalendar;
                if (!vm.ShowBryntumCalendar) {
                    // Close tooltip when tempo calendar view is enabled
                    vm.schedulerConfig.features.timeSelection.selectedTimeSpan = null; // closing selected date range and tooltip
                }
                vm.filterObj.propertyId = "-99"
                vm.filterObj.UnitClassId = "-99"
                vm.myValue = "1"
                if (document.getElementById('container')) {
                    document.getElementById('container').innerHTML = "<h5>Beta Calendar</h5>";
                }
                vm.schedulerConfig = null;
                vm.infiniteScrollDirection = '';
                vm.pageNo = 1;
                vm.latestResponseDirection = 'past';
                vm.dateRequestType = '';
                vm.recursiveCallCounter = 0;
                vm.betaStartDate = moment().format("MMMM YYYY");
                if (vm.ShowBryntumCalendar) {
                    vm.getBryntumSchedulerTapeChartData();
                } else {
                    vm.getTapeChartData();
                }
                localStorage.setItem('ShowBryntumCalendar', vm.ShowBryntumCalendar);
                // window.dispatchEvent(new Event('storageChanged'));
            },
            myRatePlanSelectEvent(e) {
                console.log("mySelectEvent == > ", e)
                let ratePlanValue = this.ratePlanList.filter(obj => obj.text == e.text);
                this.myValue = ratePlanValue[0].id;
            },
            myChangeEvent(val) {
                console.log(val);
            },
            mySelectEvent({ id, text }) {
                console.log({ id, text })
            },
            // onSelectRates(rates) {
            //     let vm = this;
            //     console.log(rates);
            //     vm.ratePlanId = rates.RatePlanId;
            // },
            getRatePlanDetailList(SearchText, Tagtext) {
                let vm = this;
                vm.$store.dispatch("dataRequestHandler", {
                    key: "GetRateplanList_bysearch",
                    params: {
                        StatusId: 1,
                        SearchText: SearchText,
                        Tagtext: Tagtext,
                    },
                    callback: function (err, response) {
                        if (err) {
                            console.log("Get_RatePlanList==>", err);
                            return;
                        }
                        if (response) {
                            console.log("Get_RatePlanList==>", response);
                            vm.ratePlanList = response[1];
                            for (let rateplan of vm.ratePlanList) {
                                if (rateplan.IsDefault) {
                                    vm.myValue = rateplan.id

                                }
                            }
                            if (vm.ShowBryntumCalendar) {
                                vm.getBryntumSchedulerTapeChartData();
                            } else {
                                vm.getTapeChartData();
                            }
                        }
                    }
                });
            },

            GetUserEntitlementsAndDefaultProperty() {
                let vm = this;
                vm.$store.dispatch("dataRequestHandler", {
                    key: "GetUserEntitlementsAndDefaultProperty",
                    params: {
                        ModuleAction: "GetUserEntitlementsAndDefaultProperty"
                    },
                    callback: function (err, response) {
                        if (err) {
                            return;
                        }
                        if (response) {
                            console.log(
                                "response in GetUserEntitlementsAndDefaultProperty",
                                response
                            );
                            // vm.UserProperties = response.properties;
                            vm.entitlements = response.userEntitlementList;

                        }
                    }
                });
            },
            navigateToReservation(resObj) {
                console.log(resObj);
                //this.$router.push("/newReservation/" + resObj.ReservationId);
                this.currentUnitObj = {}                                
                this.currResObj = resObj;
                this.$set(this.currResObj, "update", !this.currResObj.update);
            },
            showFilterByType(filterCol) {
                let vm = this;
                setTimeout(function () {
                    vm.selectedFilterColumn = filterCol;
                    if (filterCol == "property") {
                        if (vm.filterObj.Properties.length == 0) {
                            vm.getPropertiesBySearchText();
                        }
                        $("#propertyDropDown").show();
                    }
                });
            },
            getPropertiesBySearchText(searchText) {
                let vm = this;
                vm.$store.dispatch("dataRequestHandler",
                    {
                        key: "GetPropertiesBySearchText",
                        params: {
                            searchText: searchText
                        },
                        callback: function (err, response) {
                            if (err) {
                                return;
                            }
                            if (response) {
                                vm.propertyList.splice(0, vm.propertyList.length, ...response.propertyList);
                                //vm.filterObj.propertyId = vm.propertyList[0]["PropertyId"];
                                //vm.getTapeChartData();
                            }
                        }
                    });
            },
            GetUnitClasssListBySearchText(searchText) {
                let vm = this;
                vm.$store.dispatch("dataRequestHandler",
                    {
                        key: "GetUnitClasssListBySearchText",
                        params: {
                            searchText: searchText,
                            PropertyId: vm.filterObj.propertyId == -99 ? "" : vm.filterObj.propertyId
                        },
                        callback: function (err, response) {
                            if (err) {
                                return;
                            }
                            if (response) {
                                console.log("response", response);
                                vm.unitClassList.splice(0, vm.unitClassList.length, ...response.unitClassList);
                                vm.filterObj.UnitClassId = "-99";
                            }

                        }
                    });
            },
            addPropertyToFilter(propertyObj) {
                let vm = this;
                vm.filterObj.Properties.push(propertyObj);
                vm.filterSearchPropertyText = null;
                var index = vm.propertyList.indexOf(propertyObj);

                if (index > -1) {
                    vm.propertyList.splice(index, 1);
                }
                vm.selectedFilterColumn = null;
            },
            removePropertyFromFilter(propertyObj) {
                let vm = this;
                var index = vm.filterObj.Properties.indexOf(propertyObj);
                if (index > -1) {
                    vm.filterObj.Properties.splice(index, 1);
                }
                vm.propertyList.push(propertyObj);
            },
            selectedRatePlan(){
                let vm = this;
                if (vm.ShowBryntumCalendar) {
                    vm.getBryntumSchedulerTapeChartData();
                    if(vm.selectedStartDate && vm.selectedEndDate){
                        let eventsToRemove = [];
                        if(vm.schedulerConfig){
                            vm.schedulerConfig.eventStore.forEach(event => {
                                if(event.data.cls == "availableUnitPriceOverlay") {
                                    eventsToRemove.push(event);
                                } 
                            });
                            vm.schedulerConfig.eventStore.remove(eventsToRemove);
                        }
                        $(".b-theme-stockholm")[0].innerHTML = ""
                        vm.getAvailableUnitList();
                    }
                }else{
                    return
                }
            },
            applyFilter() {
                let vm = this;
                vm.latestResponseDirection = 'past';
                vm.dateRequestType = '';
                vm.recursiveCallCounter = 0;
                if (vm.ShowBryntumCalendar) {
                    vm.schedulerConfig.features.timeSelection.selectedTimeSpan = null; // closing selected date range and tooltip
                    if (document.getElementById('container')) {
                    document.getElementById('container').innerHTML = "<h5>Beta Calendar</h5>";
                    console.log("vm.filterObj.startDate = ", vm.filterObj.startDate, moment(vm.filterObj.startDate).add(90, 'days').format("DD MMM YYYY"))
                    vm.filterObj.endDate = moment(vm.filterObj.startDate).add(90, 'days').format("DD MMM YYYY");
                    }
                    vm.schedulerConfig = null;
                    vm.infiniteScrollDirection = '';
                    vm.getBryntumSchedulerTapeChartData();
                } else {
                    vm.getTapeChartData();
                }
            },
            updateSchedulerConfig() {
                let vm = this;
                vm.schedulerConfig.features.timeSelection.selectedTimeSpan = null; // closing selected date range and tooltip
                vm.schedulerConfig = null;
            },
            getTapeChartData() {
                let vm = this;
                // if (vm.filterObj.propertyId == null || vm.filterObj.propertyId == "-99") {
                //     vm.$store.dispatch("toastr", {
                //         type: "warning",
                //         header: "Tapechart",
                //         message: "Please select property"
                //     });
                //     return;
                // }

                let RatePlanId = vm.ratePlanList.filter(
                    obj => obj.id == vm.myValue
                );
                console.log("RatePlanIdRatePlanIdRatePlanId", RatePlanId)
                vm.isLoading = true;

                let startDate = vm.filterObj.startDate ? moment(vm.filterObj.startDate).format("YYYY-MM-DD") : moment().add(-2, 'days').format("YYYY-MM-DD"),
                    endDate = vm.filterObj.endDate ? moment(vm.filterObj.endDate).format("YYYY-MM-DD") : moment(startDate).add(90, 'days').format("YYYY-MM-DD");

                    // Executes on initial load
                    if (!vm.filterObj.startDate) 
                        vm.filterObj.startDate = startDate;
                    if (!vm.filterObj.endDate)
                        vm.filterObj.endDate = endDate;

                vm.$store.dispatch("dataRequestHandler", {
                    key: "GetTapeChartData_New",
                    params: {
                        startDate: startDate,
                        endDate: endDate,
                        propertyId: vm.filterObj.propertyId,
                        unitId: null,
                        UnitClassId: vm.filterObj.UnitClassId,
                        RatePlanId: RatePlanId[0].RatePlanId ? Number(RatePlanId[0].RatePlanId) : null
                    },
                    callback: function (err, response) {
                        if (err) {
                            console.log("err in GetCalendarViewData", err);
                            return
                        }
                        if (response) {
                            console.log("Response - GetTapeChartData_New", response);
                            if (response.errorMessage) {
                                vm.$store.dispatch("toastr", {
                                    type: "error",
                                    header: "CalendarView",
                                    message: response.errorMessage
                                });
                                return;
                            }
                            //on horizontal scroll removed toaster in bryntum schedular
                            // vm.$store.dispatch("toastr", {
                            //     type: "success",
                            //     header: "CalendarView",
                            //     message: "CalendarView data retreived successfully"
                            // });
                            vm.reactGridInstance.init({
                                _data: response.reservations,
                                _dateHeaders: response.dates,
                                _ratesCount: response.ratesCount,
                                _units: response.units,
                                _properties: response.properties,
                                _clientWeekends: response.clientWeekends,
                                _events: {
                                    navigateToReservation: vm.navigateToReservation,
                                    showUnAssignReservations: vm.showUnAssignReservations,
                                    showLoading: vm.showLoading
                                },
                                _filterObj: vm.filterObj,
                                _clientType: response.clientType
                            });
                            // var itemsWrap = $("#tagScrollSection").width();
                            // var tagBtnGrp = $(".tagBtnGrp").width();
                            // var calcWidth = itemsWrap + 300;
                            // if (calcWidth >= tagBtnGrp) {
                                // vm.scrlBtns = true;
                            // }
                            // else {
                                // vm.scrlBtns = false;
                            // }
                             vm.isLoading = false;
                        }
                    }
                })
            },
            getAvailableUnitList(searchByUnitType) {
                let vm = this;
                let RatePlanId = vm.ratePlanList.filter(
                    obj => obj.id == vm.myValue
                );
                vm.$store.dispatch("dataRequestHandler", {
                    key: "GetAvailableRooms",
                    params: {
                        ModuleAction: "GetAvailableRooms",
                        Adults: null,
                        Persons: vm.numberOfPersons,
                        NoOfChildren: null,
                        PropertyID: vm.filterObj.propertyId == '-99' ? '' : vm.filterObj.propertyId,
                        UnitClassId: vm.filterObj.UnitClassId == '-99' ? '' : vm.filterObj.UnitClassId,
                        StartDate: moment(vm.selectedStartDate).format("YYYY-MM-DD"),
                        EndDate: moment(vm.selectedEndDate).format("YYYY-MM-DD"),
                        FilteredAmenities: [],
                        reservationId: -1,
                        unitTypeIds: '',
                        searchByUnit: searchByUnitType && searchByUnitType == 'searchByUnitType' ? false : vm.searchByUnits,
                        ratePlans: RatePlanId[0].RatePlanId ? Number(RatePlanId[0].RatePlanId) : null,
                        promoCodes: null,
                        splitReservations: false
                    },
                    callback: function (err, response) {
                        console.log("SearchAvailability DateRangeSelection - GetAvailableRooms Response", response);
                        if (err) {
                            return;
                        }
                        if (response) {
                            if (response.resultSet &&
                            response.resultSet[0] &&
                            response.resultSet[0].hasOwnProperty("ErrorMessage") &&
                            (response.resultSet[0].ErrorMessage !== null ||
                                response.resultSet[0].ErrorMessage !== "" ||
                                response.resultSet[0].ErrorMessage !== undefined)
                            ) {
                                vm.$store.dispatch("toastr", {
                                    type: "error",
                                    header: "Error!",
                                    message: response.resultSet[0].ErrorMessage
                                });
                            } else {
                                console.log("response in SearchAvailability DateRangeSelection - GetAvailableRooms", response);
                                if(searchByUnitType != "searchByUnitType"){
                                    vm.availableUnitsList = [];
                                } else {
                                    vm.unassignAvailUnits = [];
                                }
                                if (response && response.roomDetailsListObjs && response.roomDetailsListObjs.length > 0) {
                                    if(searchByUnitType != "searchByUnitType"){
                                        vm.availableUnitsList = response.roomDetailsListObjs;

                                        //adding total amount overlay for available units -- start
                                        let searchAvailableUnitList = vm.availableUnitsList;
                                    
                                    // if (vm.clientType[0].IsHostMode) {
                                        let addEventsOverlay = searchAvailableUnitList
                                        .filter(unit => unit.Unitactualinventory === 1)
                                        .map(unit => {
                                            let avalUnitId = unit.UnitId
                                            // if(searchByUnitType == "searchByUnitType"){
                                            //     let uVal = vm.schedulerConfig.resourceStore.data.filter(unitData => unitData.IsAssigned == 0 && unitData.UnitTypeId == unit.UnitId)
                                            //     if(uVal.length){
                                            //         avalUnitId = uVal[0].UnitId
                                            //     }
                                            // }
                                            return {
                                                name : '$ '+unit.FromTotalValue,
                                                otherName : '('+vm.formatFromNightlyCharges(unit.FromNightlyCharges)+' ADR)',
                                                resourceId : avalUnitId,
                                                //iconCls : 'b-fa b-fa-star',
                                                cls : 'availableUnitPriceOverlay',
                                                eventColor : 'gray',
                                                eventStyle : 'border',
                                                resizable : false,
                                                startDate : vm.selectedStartDate,
                                                endDate : vm. selectedEndDate
                                            };
                                        });
                                        vm.schedulerConfig.eventStore.add(addEventsOverlay);
                                    }
                                        
                                        if(searchByUnitType == "searchByUnitType"){
                                            let unassignAvailableUnits = response.roomDetailsListObjs;
                                            vm.unassignAvailUnits = unassignAvailableUnits;
                                            let addEventsOverlayunassign = unassignAvailableUnits
                                            .filter(unit => unit.Unitactualinventory === 1)
                                            .map(unit => {
                                                let avalUnitId = unit.UnitId
                                                // if(searchByUnitType == "searchByUnitType"){
                                                    let uVal = vm.schedulerConfig.resourceStore.data.filter(unitData => unitData.IsAssigned == 0 && unitData.UnitTypeId == unit.UnitId)
                                                    if(uVal.length){
                                                        avalUnitId = uVal[0].UnitId
                                                    }
                                                // }
                                                return {
                                                    name : '$ '+unit.FromTotalValue,
                                                    otherName : '('+vm.formatFromNightlyCharges(unit.FromNightlyCharges)+' ADR)',
                                                    resourceId : avalUnitId,
                                                    //iconCls : 'b-fa b-fa-star',
                                                    cls : 'availableUnitPriceOverlay',
                                                    eventColor : 'gray',
                                                    eventStyle : 'border',
                                                    resizable : false,
                                                    startDate : vm.selectedStartDate,
                                                    endDate : vm. selectedEndDate
                                                };
                                            });
                                            vm.schedulerConfig.eventStore.add(addEventsOverlayunassign);
                                        }
                                    
                                        // setTimeout(function() {
                                        //     $(".b-sch-color-gray").css("z-index", "14");
                                        // }, 100)
                                    // } else {
                                    //     //Hotel mode adding overlays
                                    //     let resList_HotelMode = vm.schedulerConfig.resourceStore.query(resource => searchAvailableUnitList.some(function(searchUnit) { 
                                    //         if (searchUnit.UnitId == resource.UnitTypeId && searchUnit.Unitactualinventory == 1) {
                                    //                 resource.FromTotalValue = searchUnit.FromTotalValue;
                                    //                 resource.FromNightlyCharges = searchUnit.FromNightlyCharges;
                                    //                 return true;
                                    //         }
                                    //     }));
                                    //     // const minStayValues = resList_HotelMode.map(item => item.MinofMinstay);
                                    //     // let minOfMinStay = Math.min(...minStayValues);
                                    //     let addEventsOverlay = resList_HotelMode.map(unit => {
                                    //         return {
                                    //             name : '$ '+unit.FromTotalValue,
                                    //             otherName : '('+vm.formatFromNightlyCharges(unit.FromNightlyCharges)+' ADR)',
                                    //             resourceId : unit.data.UnitId,
                                    //             //iconCls : 'b-fa b-fa-star',
                                    //             cls : 'availableUnitPriceOverlay',
                                    //             eventColor : 'gray',
                                    //             eventStyle : 'border',
                                    //             resizable : false,
                                    //             startDate : vm.selectedStartDate,
                                    //             endDate : vm. selectedEndDate
                                    //         };
                                    //     });
                                    //     vm.schedulerConfig.eventStore.add(addEventsOverlay);
                                    // }
                                    // adding overlay -- end
                                } else {
                                    // Removing available units overlay
                                    let eventsToRemove = [];
                                    if(vm.schedulerConfig){
                                        vm.schedulerConfig.eventStore.forEach(event => {
                                            if(event.data.cls == "availableUnitPriceOverlay") {
                                                eventsToRemove.push(event);
                                            } 
                                        });
                                        vm.schedulerConfig.eventStore.remove(eventsToRemove);
                                    }
                                }
                                var listingCount = document.getElementById("listingCount");
                                var listingText = document.getElementById("listingText");
                                if (listingCount && searchByUnitType !="searchByUnitType") {
                                    var count = vm.availableUnitsList.filter(unit => unit.Unitactualinventory == 1).length;
                                    const minStayValues = vm.resAvailbleList.map(item => item.MinofMinstay);
                                    console.log("minStayValues", minStayValues);
                                    let minOfMinStay = Math.min(...minStayValues);
                                    const startDate = moment(vm.selectedStartDate);
                                    const endDate = moment(vm.selectedEndDate);
                                    let stayCountVal = endDate.diff(startDate, 'days');
                                    if (count > 0 || (count <= 0 && stayCountVal >= minOfMinStay)) {
                                        if (count == 0 ) {
                                            $(".bCustomTooltip").addClass("unitNotAvailableTooltip");
                                        } else {
                                            $(".unitNotAvailableTooltip").removeClass("unitNotAvailableTooltip");
                                        }
                                        listingCount.innerHTML = count;
                                        listingText.innerHTML = 'Listings'
                                    } else {
                                        $(".bCustomTooltip").addClass("unitNotAvailableTooltip");
                                        listingCount.innerHTML = minOfMinStay
                                        listingText.innerHTML = 'Nights Min'
                                    }
                                }
                                if(vm.clientType[0].IsHostMode != 1 && searchByUnitType != "searchByUnitType"){
                                    vm.getAvailableUnitList("searchByUnitType")
                                }
                            }
                        }
                    }
                });
            },
            getBryntumSchedulerTapeChartData() {
                let vm = this;
                let RatePlanId = vm.ratePlanList.filter(
                    obj => obj.id == vm.myValue
                );
                console.log("RatePlanIdRatePlanIdRatePlanId", RatePlanId)
                //vm.visibleStartDate = '';
                vm.schedulerStartDate = '';
                vm.schedulerEndDate = '';
                //Do not show loading symbol while scrolling
                if (vm.infiniteScrollDirection !== 'left' && vm.infiniteScrollDirection !== 'right') {
                    // vm.isLoading = vm.verticalInfiniteScroll ? false : true;
                    vm.visibleStartDate = vm.filterObj.startDate ? moment(vm.filterObj.startDate).format("YYYY-MM-DD") : moment().add(-2, 'days').format("YYYY-MM-DD");
                    // vm.visibleStartDate = moment().add(-2, 'days').format("YYYY-MM-DD");
                    // vm.schedulerStartDate = moment(vm.visibleStartDate).subtract(30, 'days').format("YYYY-MM-DD");
                    // vm.schedulerEndDate = moment(vm.visibleStartDate).add(30, 'days').format("YYYY-MM-DD");
                    vm.schedulerStartDate = vm.visibleStartDate;
                    vm.schedulerEndDate = moment(vm.schedulerStartDate).add(30, 'days').format("YYYY-MM-DD");
                    if (vm.dateRequestType == '') {
                        vm.isLoading = vm.verticalInfiniteScroll ? false : true;
                        vm.initialStartDate = vm.schedulerStartDate;
                        vm.initialEndDate = vm.schedulerEndDate;
                    } else if (vm.dateRequestType == 'past') {
                        vm.schedulerEndDate = moment(vm.initialStartDate).format("YYYY-MM-DD");
                        vm.schedulerStartDate = moment(vm.schedulerEndDate).subtract(30, 'days').format("YYYY-MM-DD");
                        vm.initialStartDate = vm.schedulerStartDate;
                        vm.latestResponseDirection = 'future';
                    } else if (vm.dateRequestType == 'future') {
                        vm.schedulerStartDate = moment(vm.initialEndDate).format("YYYY-MM-DD");
                        vm.schedulerEndDate = moment(vm.schedulerStartDate).add(30, 'days').format("YYYY-MM-DD");
                        vm.initialEndDate = vm.schedulerEndDate;
                        vm.latestResponseDirection = 'past'
                    }
                } else if (vm.infiniteScrollDirection === 'left' || vm.infiniteScrollDirection === 'right') {
                    // Executes when user scroll towards left / right  direction
                    vm.schedulerStartDate = moment(vm.scrollStartDate).format("YYYY-MM-DD");
                    vm.schedulerEndDate = moment(vm.scrollEndDate).format("YYYY-MM-DD");
                    if (vm.infiniteScrollDirection === 'left') {
                        vm.initialStartDate = (vm.initialStartDate > vm.schedulerStartDate) ? vm.schedulerStartDate : vm.initialStartDate;
                    } else if (vm.infiniteScrollDirection === 'right') {
                        vm.initialEndDate = (vm.initialEndDate < vm.schedulerEndDate) ? vm.schedulerEndDate : vm.initialEndDate;
                    }
                } 
                console.log("schedulerStartDate:",vm.schedulerStartDate,"schedulerEndDate",vm.schedulerEndDate);
                
                // Executes on initial load 
                // (Setting filterObj.startDate and filterObj.endDate values to show in inventory panel)
                if (!vm.filterObj.startDate) 
                    vm.filterObj.startDate = vm.visibleStartDate;
                if (!vm.filterObj.endDate)
                    vm.filterObj.endDate = moment(vm.visibleStartDate).add(90, 'days').format("YYYY-MM-DD");
                
                vm.$store.dispatch("dataRequestHandler", {
                    key: "GetTapeChartData_New_Bryntum",
                    params: {
                        DateStart: vm.schedulerStartDate,
                        DateEnd: vm.schedulerEndDate,
                        PropertyId: null,//vm.filterObj.propertyId,
                        UnitId: null,
                        UnitClassId: null, //vm.filterObj.UnitClassId,
                        RatePlanId: RatePlanId[0].RatePlanId ? Number(RatePlanId[0].RatePlanId) : null,
                        PageNo: vm.pageNo,
                        ItemsPerPage: vm.itemsPerPage,
                        // Beds: vm.panelFilterObj && vm.panelFilterObj.filterObj && vm.panelFilterObj.filterObj.Beds ? vm.panelFilterObj.filterObj.Beds : null,
                        // Bedrooms: vm.panelFilterObj && vm.panelFilterObj.filterObj && vm.panelFilterObj.filterObj.Bedrooms ? vm.panelFilterObj.filterObj.Bedrooms : null,
                        // Bathrooms: vm.panelFilterObj && vm.panelFilterObj.filterObj && vm.panelFilterObj.filterObj.Bathrooms ? vm.panelFilterObj.filterObj.Bathrooms : null,
                        // Amenities: vm.panelFilterObj && vm.panelFilterObj.filterObj && vm.panelFilterObj.filterObj.AmenitiesList && vm.panelFilterObj.filterObj.AmenitiesList.length? vm.panelFilterObj.filterObj.AmenitiesList.map(obj => obj["listid"]).join(',') : null,
                    },
                    callback: function (err, response) {
                        if (err) {
                            console.log("err in GetTapeChartData_New_Bryntum", err);
                            return
                        }
                        if (response) {
                            console.log("Response - GetTapeChartData_New_Bryntum", response);
                            if (response.errorMessage) {
                                vm.$store.dispatch("toastr", {
                                    type: "error",
                                    header: "CalendarView",
                                    message: response.errorMessage
                                });
                                return;
                            }
                            vm.clientType = response.clientType;
                            vm.$refs.calendarFilterPanel.isHostModeObj = vm.clientType;
                            vm.recursiveCallCounter = vm.recursiveCallCounter+1;
                            if (vm.recursiveCallCounter <= 2) {
                                vm.dateRequestType = (vm.latestResponseDirection == 'past') ? 'past' : 'future';
                                vm.getBryntumSchedulerTapeChartData();
                                console.log("BryntumSchedulerTapeChartData_New",vm.recursiveCallCounter)
                            } else {
                                vm.dateRequestType = '';
                                vm.latestResponseDirection = 'past';
                            }
                            setTimeout(async function () {
                                if (document.getElementById('container')) {
                                    // vm.schedulerConfig = getDataConfig(response, Scheduler, vm);
                                    //vm.getBryntumResponseDetails(response);
                                    if (vm.schedulerConfig == undefined) {
                                        vm.schedulerConfig = {
                                            response: response,
                                            summaryRenderValue: "soldunits"
                                        }
                                        vm.schedulerConfig = getDataConfig(response, Scheduler, vm, DomClassList, vm.panelFilterObj);
                                    } else {
                                        var resources = [];
                                        var resourceTimeRanges = [];
                                        var events = [];
                                        var unitDates = vm.schedulerConfig.response.dateSummary.map(function (date) {
                                            return date;
                                        })
                                        var unitTypeDates = vm.schedulerConfig.response.groupSummaryResponse.map(function (date) {
                                            return date;
                                        })
                                        vm.schedulerConfig.response = response;
                                        //This is to update the footer button values while scrolling soldunit/available/occupancy
                                        vm.schedulerConfig.response.dateSummary = vm.schedulerConfig.response.dateSummary.concat(unitDates);
                                        vm.schedulerConfig.response.groupSummaryResponse = vm.schedulerConfig.response.groupSummaryResponse.concat(unitTypeDates);
                                        // resources = vm.schedulerConfig.resources.map(function(resource) {
                                        //         return resource.data;
                                        // })
                                        // resources = resources.concat(response.bryntumResponse.resources);
                                        resources = response.bryntumResponse.resources
                                        // resourceTimeRanges = vm.schedulerConfig.resourceTimeRanges.map(function(resource) {
                                        //     return resource.data;
                                        // })
                                        // resourceTimeRanges = resourceTimeRanges.concat(response.bryntumResponse.resourceTimeRanges);
                                        resourceTimeRanges = response.bryntumResponse.resourceTimeRanges
                                        events = vm.schedulerConfig.events.map(function (resource) {
                                            return resource.data;
                                        })
                                        events = events.concat(response.bryntumResponse.events);
                                        // events = response.bryntumResponse.events;

                                        // vm.schedulerConfig.project.inlineData.eventsData = events;
                                        // vm.schedulerConfig.project.resourceTimeRangesData = resourceTimeRanges;
                                        //vm.schedulerConfig.eventStore.autoCommit = true;
                                        //vm.schedulerConfig.resourceTimeRangeStore.autoCommit = true;

                                        let eventsList = vm.getUniqueEventsList(events);

                                        if (vm.pageNo > 1) {
                                            await vm.schedulerConfig.resourceStore.addAsync(resources);
                                        }
                                        await vm.schedulerConfig.eventStore.addAsync(eventsList);
                                        // await vm.schedulerConfig.eventStore.project.commitAsync();
                                        await vm.schedulerConfig.resourceTimeRangeStore.add(resourceTimeRanges);
                                        await vm.schedulerConfig.resourceTimeRangeStore.commit();
                                        // vm.schedulerConfig.features.summary.refresh();

                                        //vm.schedulerConfig.refreshRows();
                                        // await vm.schedulerConfig.resourceTimeRangeStore.project.commitAsync();

                                    }
                                }
                                if (vm.panelFilterObj && vm.ShowBryntumCalendar) {
                                    vm.filterpanelCallback(vm.panelFilterObj, "tapechartdata")
                                }
                                vm.isLoading = false;
                            }, 100)

                        }
                    }
                })
            },
            async showUnassignedRes(resourceRecord, source, scrollStartDate, scrollEndDate) {
                let vm = this;
                // let resObj = resourceRecord.data;
                let resObj = (resourceRecord != undefined) ? resourceRecord.data : null; 
                //Bryntum start date calculating past 90 and future 90 days from current date.
                let startDate = (resourceRecord != undefined) ? resourceRecord.timeRanges[0].startDate : '';
                vm.isLoading = true;
                if (resourceRecord != undefined) {
                    vm.resourceRecordObj = resourceRecord.data

                    // vm.unassignStartDate = moment.utc(startDate).subtract(30,'days').format("YYYY-MM-DD")
                    // vm.unassignEndDate = moment.utc(startDate).add(30,'days').format("YYYY-MM-DD")
                    
                    //Added vm.schedulerConfig.visibleDateRange.startDate when unassigned row expandedin middle after scroll
                    vm.unassignStartDate = moment.utc(vm.schedulerConfig.visibleDateRange.startDate).subtract(30,'days').format("DD MMM YYYY");
                    vm.unassignEndDate = moment.utc(vm.schedulerConfig.visibleDateRange.startDate).add(30,'days').format("DD MMM YYYY");

                    vm.unassign_InitialStartDate = vm.unassignStartDate
                    vm.unassign_InitialEndDate = vm.unassignEndDate
                    // console.log('unassignStartDate:',vm.unassignStartDate,'unassignEndDate:',vm.unassignEndDate)
                } else {
                    // Executes when user scroll towards left / right  direction
                    vm.unassignStartDate = scrollStartDate
                    vm.unassignEndDate = scrollEndDate
                    // vm.schedulerStartDate = moment(vm.scrollStartDate).format("YYYY-MM-DD");
                    // vm.schedulerEndDate = moment(vm.scrollEndDate).format("YYYY-MM-DD");
                    if (vm.infiniteScrollDirection === 'left') {
                        vm.unassign_InitialStartDate = (vm.unassign_InitialStartDate > vm.unassignStartDate) ? vm.unassignStartDate : vm.unassign_InitialStartDate;
                    } else if (vm.infiniteScrollDirection === 'right') {
                        vm.unassign_InitialEndDate = (vm.unassign_InitialEndDate < vm.unassignEndDate) ? vm.unassignEndDate : vm.unassign_InitialEndDate;
                    }
                    // console.log('unassign_InitialStartDate:',vm.unassign_InitialStartDate,'unassign_InitialEndDate:',vm.unassign_InitialEndDate)
                }
                // console.log('unassignStartDate:',vm.unassignStartDate,'unassignEndDate:',vm.unassignEndDate)
                // console.log('unassignscrollStartDate:',scrollStartDate,'unassignscrollEndDate:',scrollEndDate)
                const data = new FormData();
                data.append('requestParams', JSON.stringify({
                    // startDate: vm.filterObj.startDate ? moment.utc(vm.filterObj.startDate).format("YYYY-MM-DD") : moment.utc().format("YYYY-MM-DD"),
                    // endDate: vm.filterObj.endDate ? moment.utc(vm.filterObj.endDate).format("YYYY-MM-DD") : moment.utc().add(90, 'days').format("YYYY-MM-DD"),
                    startDate: (scrollStartDate != undefined) ? scrollStartDate : vm.unassignStartDate,
                    endDate: (scrollEndDate != undefined) ? scrollEndDate : vm.unassignEndDate,
                    propertyId: resObj ? resObj.PropertyId : vm.resourceRecordObj.PropertyId, //61,//resObj.PropertyId,
                    unitId: resObj ? resObj.id : vm.resourceRecordObj.id, //264,//resObj.id,
                    UnitClassId: resObj ? resObj.UnitClassId : vm.resourceRecordObj.UnitClassId, //-1,//resObj.UnitClassId,
                    RatePlanId: resObj ? resObj.RateplanId : vm.resourceRecordObj.RateplanId,//9,//resObj.RateplanId,
                    APIReg: 10010,
                    source: source
                })
                );
                data.append('systemParams', JSON.stringify({
                    token: window.localStorage.getItem('rttoken'),
                    Source: "Web",
                    SourceId: window.location.hostname,
                }));

                await fetch(window.location.protocol + "//" + window.location.hostname + (window.location.port ? ":1339" : '') + '/api', {
                    method: 'POST',
                    body: data
                }).then(response => {
                    response.json().then(async formattedResponse => {
                        if (formattedResponse.err) {
                            console.log("Error returned from server => ", formattedResponse.err);
                            return;
                        }
                        if (formattedResponse.response) {
                            console.log("showUnassignedResresponse", formattedResponse);
                            let responseObj = formattedResponse.response;
                            var events = [];
                            events = vm.schedulerConfig.events.map(function (resource) {
                                return resource.data;
                            });
                            //if (resourceRecord.originalData.eventLayout == 'stack') {
                                  
                                // sorting unassigned events to show latest on top
                                let allEvents = responseObj.bryntumResponse.events;
                                allEvents.sort((a, b) => new Date(b.bookeddate) - new Date(a.bookeddate));
                                vm.unassignedUnitEvents = allEvents;

                                // vm.unassignedUnitEvents = responseObj.bryntumResponse.events;
                                // events = events.concat(responseObj.bryntumResponse.events);
                                events = events.concat(vm.unassignedUnitEvents);
                                // $($(".unassignedResCount" + resObj ? resObj.unitId : vm.resourceRecordObj.unitId)).find(".reservation").addClass("cellData")
                                $($(".unassignedResCount" + (resObj ? resObj.unitId : vm.resourceRecordObj.unitId))).find(".reservation").addClass("cellData");
                                // resourceRecord.rowHeight = 50 + (responseObj.bryntumResponse.events.length * 35);                                                                                       
                            //}
                            // else if (resourceRecord.eventLayout == 'none') {
                            //     const reservationIdsToRemove = responseObj.bryntumResponse.events.map(item => item.reservationId);
                            //     const filteredEvents = events.filter(item => !reservationIdsToRemove.includes(item.reservationId));
                            //     events = filteredEvents;
                            //     resourceRecord.rowHeight = 50;
                            // }
                            // events = events.concat(responseObj.bryntumResponse.events);
                            let eventsList = vm.getUniqueEventsList(events);
                            await vm.schedulerConfig.eventStore.addAsync(eventsList);
                        }
                    });
                });
                vm.isLoading = false;
            },
            async removeEvents(resourceRecord) {
                let vm = this;
                console.log("Response", resourceRecord.originalData.id);
                var events = [];
                events = vm.schedulerConfig.events.map(function (resource) {
                    return resource.data;
                });
                // const reservationIdsToRemove = vm.unassignedUnitEvents.map(item => item.resourceId);
                const filteredEvents = events.filter(item => item.resourceId == resourceRecord.originalData.id);
                let eventRemoveListIds = filteredEvents.map(event => event.id)
                // events = filteredEvents;
                // let eventsList = vm.getUniqueEventsList(events);
                console.log("reservationIdsToRemove", eventRemoveListIds)
                $($(".unassignedResCount" + resourceRecord.UnitId)).find(".reservation").removeClass("cellData")
                await vm.schedulerConfig.eventStore.remove(eventRemoveListIds);
                if (resourceRecord.originalData.eventLayout == 'none') {
                    resourceRecord.rowHeight = 55;
                }
                // vm.schedulerConfig.eventStore._data = []
                // await vm.schedulerConfig.eventStore.addAsync([eventsList]);
            },
            updateFilterStartDate(key, dateObj, objectPassedToParent) {
                objectPassedToParent.startDate = dateObj ? dateObj.format("DD MMM YYYY") : null;
            },
            updateFilterEndDate(key, dateObj, objectPassedToParent) {
                objectPassedToParent.endDate = dateObj ? dateObj.format("DD MMM YYYY") : null;
            },
            onChangeReservationStatus(resStatusId) {

            },
            async clearAllFilters() {
                var vm = this;
                vm.$refs.calendarFilterPanel.clearAllFilters()
                vm.scrlBtns = false
                // vm.filterTooltipAction = false;
                // vm.schedulerConfig.resourceStore.clearFilters();
                vm.isFilteredApplied =  false;

                vm.filterObj.propertyId = -99;
                vm.filterObj.UnitClassId = [];
                vm.filterObj.Amenities = [];
                vm.filterObj.Bathrooms = null;
                vm.filterObj.Bedrooms = null;
                vm.filterObj.Beds = null;
                vm.getAvailableUnitList();

            },
            deleteSelectedFromFilter(filterType) {
                let vm = this;
                vm.$refs.calendarFilterPanel.deleteSelectedFromFilter(filterType);

                vm.$refs.calendarFilterPanel.stayDateRange.startDate =  null;
                vm.$refs.calendarFilterPanel.stayDateRange.endDate =  null;

                vm.isFilteredApplied =  false;

                switch (filterType) {
                    case "Properties":
                        vm.filterObj.propertyId = -99;
                        break;
                    case "UnitClasses":
                    case "unitList":
                        vm.filterObj.UnitClassId = [];
                        break;
                    case "AmenitiesList":
                        vm.filterObj.Amenities = [];
                        break;
                    case "Bathrooms":
                    case "Bedrooms":
                    case "Beds":
                        vm.filterObj[filterType] = null;
                        break;
                }
                vm.getAvailableUnitList();
            },
            deleteSelectedColumnFromFilter(index, column) {
                let vm = this;
                vm.$refs.calendarFilterPanel.deleteSelectedColumnFromFilter(column);

                vm.$refs.calendarFilterPanel.filterColumnsDateRange.startDate =  null;
                vm.$refs.calendarFilterPanel.filterColumnsDateRange.endDate =  null;
            },
            filterpanelCallback(data, fromfile) {
                let vm = this;
                if(fromfile != 'tapechartdata'){
                    vm.toggleFilterPanel = data && data.toggleFilterPanel ? data.toggleFilterPanel : false
                }
                // vm.panelFilterObj = { ...data }
                if (data.closePanel) {
                    return
                }
                vm.isFilteredApplied = true
                vm.panelFilterObj = JSON.parse(JSON.stringify(data));
                console.log("filterobj: ", data.filterObj)
                console.log("viewSaveObject: ", data.viewSaveObject)
                // let startDate = vm.filterObj.startDate
                // vm.myValue = data.filterObj.rateplanList.length ? data.filterObj.rateplanList : "1"
                // || (data.filterObj.startdate) || (!data.filterObj.startdate && vm.previousDateFilter))
                // (data.filterObj.rateplanList.length) || (!data.filterObj.rateplanList.length && vm.previousRateplanFilter && vm.previousRateplanFilter.length)
                if (!fromfile && fromfile != 'tapechartdata' && ((data.filterObj.rateplanList.length) || (!data.filterObj.rateplanList.length && vm.previousRateplanFilter && vm.previousRateplanFilter.length))) {
                    // vm.previousDateFilter = data.filterObj.startdate
                    vm.previousRateplanFilter = data.filterObj.rateplanList
                    // vm.filterObj.startDate = data.filterObj.startdate ? data.filterObj.startdate : moment().subtract(2, 'days').format("DD MMM YYYY")
                    vm.applyFilter()
                    return
                }
                // if (!fromfile && fromfile !== 'tapechartdata') {
                //     const filterObj = data.filterObj;
                //     const vmFilterObj = vm.filterObj;

                //     const hasProperties = filterObj.Properties.length || (!filterObj.Properties.length && vmFilterObj.Properties.length);
                //     const hasUnitClasses = filterObj.UnitClasses.length || (!filterObj.UnitClasses.length && vmFilterObj.UnitClasses.length);
                //     const hasUnitTypes = filterObj.UnitTypes.length || (!filterObj.UnitTypes.length && vmFilterObj.UnitTypes.length);
                //     const hasUnitList = filterObj.unitList.length || (!filterObj.unitList.length && vmFilterObj.unitList.length);
                //     const hasAmenitiesList = filterObj.AmenitiesList.length || (!filterObj.AmenitiesList.length && vmFilterObj.AmenitiesList.length);
                //     const hasBeds = filterObj.Beds || (!filterObj.Beds && vmFilterObj.Beds);
                //     const hasBedrooms = filterObj.Bedrooms || (!filterObj.Bedrooms && vmFilterObj.Bedrooms);
                //     const hasBathrooms = filterObj.Bathrooms || (!filterObj.Bathrooms && vmFilterObj.Bathrooms);

                //     if (hasProperties || hasUnitClasses || hasUnitTypes || hasUnitList || hasBeds || hasBedrooms || hasBathrooms || hasAmenitiesList) {
                //         // vm.previousDateFilter = filterObj.startdate;
                //         // vm.previousRateplanFilter = filterObj.rateplanList;
                //         vmFilterObj.Properties = filterObj.Properties;
                //         vmFilterObj.UnitClasses = filterObj.UnitClasses;
                //         vmFilterObj.UnitTypes = filterObj.UnitTypes;
                //         vmFilterObj.AmenitiesList = filterObj.AmenitiesList;
                //         vmFilterObj.unitList = filterObj.unitList;
                //         vmFilterObj.Beds = filterObj.Beds;
                //         vmFilterObj.Bedrooms = filterObj.Bedrooms;
                //         vmFilterObj.Bathrooms = filterObj.Bathrooms;

                //         // vmFilterObj.startDate = filterObj.startdate ? filterObj.startdate : moment().subtract(2, 'days').format("DD MMM YYYY");
                //         vm.applyFilter();
                //         return;
                //     }
                // }

                let RatePlan = vm.ratePlanList.filter(obj => obj.id == vm.myValue);

                let propertysearcharr = data.filterObj.Properties.length ? data.filterObj.Properties.map(val => val.PropertyId) : []
                let unitclassessearcharr = data.filterObj.UnitClasses.length ? data.filterObj.UnitClasses.map(val => val.UnitClassId) : []
                let unitsearcharr = data.filterObj.unitList.length ? data.filterObj.unitList.map(val => val.UnitId) : []
                let unittypesearcharr = data.filterObj.UnitTypes.length ? data.filterObj.UnitTypes.map(val => val.UnitTypeId) : []
                let sourcesearcharr = data.filterObj.Sources.length ? data.filterObj.Sources.map(val => val.sourceID) : []
                let statussearcharr = data.filterObj.StatusList.length ? data.filterObj.StatusList.map(val => val.StatusName) : []
                let tagssearcharr = data.filterObj.TagsList.length ? data.filterObj.TagsList.map(val => val.TagName) : []
                let rateplansearcharr = RatePlan.length ? RatePlan[0].RatePlanId : null
                let amenitiesSearcharr = data.filterObj.AmenitiesList.length ? data.filterObj.AmenitiesList.map(val => val.listname) : []
                let showUnallocatedRes = data.filterObj.showUnAllocatedReservations
                let Beds = data.filterObj.Beds
                let Bedrooms = data.filterObj.Bedrooms
                let Bathrooms = data.filterObj.Bathrooms
                let firstNamesearcharr = []
                let lastNamesearcharr = []
                let startDatesearch = null
                let endDatesearch = null
                let confirmationNumesearcharr = []
                let extconfirmationNumesearcharr = []
                let emailsearcharr = []
                let phoneNumesearcharr = []
                let bookedstartDate = null
                let bookedendDate = null
                let bookedbyuser = []
                let checkInDate = null
                let checkOutDate = null

                for (let Column of data.filterObj.Columns) {
                    if (Column.colunmName == "StayDate") {
                        startDatesearch = Column.value
                        endDatesearch = Column.rangeVal
                    }
                    if (Column.colunmName == "DateBooked") {
                        bookedstartDate = Column.value
                        bookedendDate = Column.rangeVal
                    }
                    if (Column.colunmName == "Check-inDates") {
                        checkInDate = Column.value
                        checkOutDate = Column.rangeVal
                    }
                    if (Column.colunmName == "ConfirmationNumber") {
                        confirmationNumesearcharr = Column.arrText
                    }
                    if (Column.colunmName == "GuestName") {
                        firstNamesearcharr = Column.arrText
                    }
                    if (Column.colunmName == "GuestLastName") {
                        lastNamesearcharr = Column.arrText
                    }
                    if (Column.colunmName == "SourceConfirmationNumber") {
                        extconfirmationNumesearcharr = Column.arrText
                    }
                    if (Column.colunmName == "Email") {
                        emailsearcharr = Column.arrText
                    }
                    if (Column.colunmName == "PhoneNumber") {
                        phoneNumesearcharr = Column.arrText
                    }
                    if (Column.colunmName == "BookedBy") {
                        bookedbyuser = Column.arrText
                    }
                }
                startDatesearch = data.filterObj.stayStartDate;
                endDatesearch = data.filterObj.stayEndDate;
                vm.$nextTick(function () {
                    // DOM updated
                    var itemsWrap = $("#tagScrollSection").width();
                    var tagBtnGrp = $(".tagBtnGrp").width();
                    var calcWidth = itemsWrap + 300;
                    if (calcWidth >= tagBtnGrp) {
                        vm.scrlBtns = true;
                    }
                    else {
                        vm.scrlBtns = false;
                    }

                });
                console.log("vm.schedulerConfig.element.classList =", vm.schedulerConfig.element.classList)
                // if (data.clearFilter) {
                //     vm.clearFilters()
                //     return
                // }
                // if (propertysearcharr.length || unitclassessearcharr.length) {
                // || (vm.filterObj.propertyId != "-99" && resource.data.PropertyId == vm.filterObj.propertyId)
                // || (vm.filterObj.UnitClassId != "-99" && resource.data.UnitClassId == vm.filterObj.UnitClassId)
                if (propertysearcharr.length > 0)
                    vm.filterObj.propertyId = propertysearcharr;
                if (unitclassessearcharr.length > 0)
                    vm.filterObj.UnitClassId = unitclassessearcharr;
                if (amenitiesSearcharr.length > 0)
                    vm.filterObj.Amenities = amenitiesSearcharr;

                vm.filterObj.Beds = Beds;
                vm.filterObj.Bedrooms = Bedrooms;
                vm.filterObj.Bathrooms = Bathrooms;

                setTimeout(function() {
                    vm.schedulerConfig.resourceStore.filter({
                        filters: (resource) => {
                            // Customize the resource filter logic here based on the criteria you want
                            return (!propertysearcharr.length || vm.matchesAny(resource.data.PropertyId, propertysearcharr)) &&
                                (!unitclassessearcharr.length || vm.matchesAny(resource.data.UnitClassId, unitclassessearcharr)) &&
                                (!unitsearcharr.length || vm.matchesAny(resource.data.id, unitsearcharr)) &&
                                (!unittypesearcharr.length || vm.matchesAny(resource.data.UnitTypeId, unittypesearcharr)) && 
                                (!amenitiesSearcharr.length || vm.matchesAnySting(resource.data.Amenities, amenitiesSearcharr)) && 
                                (!Beds || resource.data.Beds >= Beds) && (!Bedrooms || resource.data.Bedrooms >= Bedrooms) && 
                                (!Bathrooms || resource.data.Bathrooms >= Bathrooms)
                        },
                        replace: true,
                    });
                }, 1000);                
                vm.schedulerConfig.eventStore.forEach(event => {
                    // console.log("event.data.Tags ",event.data.Tags)
                    const taskClassList = new DomClassList(event.cls);
                    if ((!sourcesearcharr.length || vm.matchesAny(event.data.SourceId, sourcesearcharr)) &&
                        (!statussearcharr.length || vm.matchesAny(event.data.Reservationstatus, statussearcharr)) &&
                        // (!rateplansearcharr || event.data.RatePlanId == rateplansearcharr) &&
                        (!firstNamesearcharr.length || vm.matchesAnySting(event.data.name, firstNamesearcharr)) &&
                        // (!lastNamesearcharr.length || vm.matchesAnySting(event.data.name, lastNamesearcharr)) &&
                        (!startDatesearch || vm.matchesAnyStartDates(event.data.startDate, startDatesearch)) &&
                        (!endDatesearch || vm.matchesAnyEndDates(event.data.endDate, endDatesearch)) &&
                        (!tagssearcharr.length || vm.matchesAnySting(event.data.Tags, tagssearcharr)) &&
                        (!confirmationNumesearcharr.length || vm.matchesAnySting(event.data.EXTERNALCONFIRMATIONNUMBER, confirmationNumesearcharr) ||
                            vm.matchesAnySting(`HT${event.data.ConfirmationNumber}`, confirmationNumesearcharr)) &&
                        // (!confirmationNumesearcharr.length || vm.matchesAnySting(JSON.stringify(event.data.confirmationNumber), confirmationNumesearcharr))
                        (!emailsearcharr.length || vm.matchesAnySting(event.data.email, emailsearcharr)) &&
                        (!phoneNumesearcharr.length || vm.matchesAnySting(event.data.PhoneNumber, phoneNumesearcharr)) &&
                        (!bookedstartDate || vm.matchesAnyStartDates(event.data.bookeddate, bookedstartDate)) &&
                        (!bookedendDate || vm.matchesAnyEndDates(event.data.bookeddate, bookedendDate)) &&
                        (!checkInDate || vm.matchStartDate(event.data.ActualStartDate, checkInDate)) &&
                        (!checkOutDate || vm.matchEndDate(event.data.ActualEndDate, checkOutDate)) &&
                        (!bookedbyuser.length || vm.matchesAnySting(event.data.Bookedbyuser, bookedbyuser)) && 
                        (!showUnallocatedRes || (showUnallocatedRes && event.data.Oversell))) {
                        taskClassList.add('b-match');
                        // console.log(vm.matchesAny(event.data.Reservationstatus, statussearcharr),event.data.Reservationstatus,statussearcharr[0],"object1",event.data.name,event.data)
                    }
                    else {
                        taskClassList.remove('b-match');
                        // console.log(vm.matchesAny(event.data.Reservationstatus, statussearcharr),event.data.Reservationstatus,statussearcharr[0],"object2",event.data.name,event.data)
                    }

                    event.cls = taskClassList.value;
                });
                // || rateplansearcharr
                vm.schedulerConfig.element.classList[(sourcesearcharr.length || tagssearcharr.length ||
                    extconfirmationNumesearcharr.length || emailsearcharr.length || phoneNumesearcharr.length
                    || bookedstartDate || bookedendDate || bookedbyuser.length || statussearcharr.length ||
                    firstNamesearcharr.length || lastNamesearcharr.length || startDatesearch || startDatesearch
                    || confirmationNumesearcharr.length || showUnallocatedRes || checkInDate  ||  checkOutDate) ? 'add' : 'remove']('b-highlighting');

                // vm.schedulerConfig.eventStore.filter({
                //     filters: (event) => {
                //         // Customize the filter logic here based on the criteria you want
                //         // ||vm.matchesAny(event.data.description, filterValues);
                //         return (!sourcesearcharr.length || vm.matchesAny(event.data.sourceId, sourcesearcharr)) &&
                //             (!statussearcharr.length || vm.matchesAny(event.data.reservationStatus, statussearcharr)) &&
                //             (!rateplansearcharr.length || vm.matchesAny(event.data.RatePlanId, rateplansearcharr)) &&
                //             (!firstNamesearcharr || vm.matchesAnySting(event.data.name, firstNamesearcharr)) &&
                //             (!lastNamesearcharr || vm.matchesAnySting(event.data.name, lastNamesearcharr)) &&
                //             (!startDatesearch || vm.matchesAnyDates(event.data.startDate, startDatesearch)) &&
                //             (!endDatesearch || vm.matchesAnyDates(event.data.endDate, endDatesearch)) &&
                //             (!confirmationNumesearcharr || vm.matchesAny(event.data.confirmationNumber, confirmationNumesearcharr))
                //     },
                //     replace: true,
                // });
                // }
                console.log("vm.schedulerConfig.element.classList ====== ", vm.schedulerConfig.element.classList)
            },
            // scrollRight: function () {
            //     var container = this.$el.querySelector("#tagScrollSection");
            //     var cnt = this.scrllCount++;
            //     container.scrollLeft = cnt;
            //     console.log("scroll counter before" + cnt);
            //     this.scrllCount = this.scrllCount + 50;
            //     console.log("scroll counter after" + cnt);
            //     this.scrollLeft = cnt;


            // },
            // scrollLeft: function () {

            //     var container = this.$el.querySelector(".scrollingTags");
            //     console.log("Inner width -" + container.clientWidth);
            //     if (this.scrllCount == -1) {
            //         var container = this.$el.querySelector("#tagScrollSection");
            //         container.scrollLeft = 0;
            //         console.log("If");
            //     } else {
            //         var container = this.$el.querySelector("#tagScrollSection");
            //         var cnt2 = this.scrllCount--;
            //         container.scrollLeft = cnt2;
            //         console.log("scroll counter before" + cnt2);
            //         this.scrllCount = this.scrllCount - 50;
            //         console.log("scroll counter after" + cnt2);
            //     }
            // },
            scrollRight: function () {
                var container = this.$el.querySelector("#tagScrollSection");
                var maxScroll = container.scrollWidth - container.clientWidth;
                if (this.scrllCount < maxScroll) {
                    this.scrllCount = Math.min(this.scrllCount + 50, maxScroll);
                    container.scrollLeft = this.scrllCount;
                    console.log("scroll counter after" + this.scrllCount);
                } else {
                    console.log("Reached the right limit");
                }
            },
            
            scrollLeft: function () {
                var container = this.$el.querySelector("#tagScrollSection");
                if (this.scrllCount > 0) {
                    this.scrllCount = Math.max(this.scrllCount - 50, 0);
                    container.scrollLeft = this.scrllCount;
                    console.log("scroll counter after" + this.scrllCount);
                } else {
                    console.log("Reached the left limit");
                }
            },
            customFilter(resources, searchArray, attribute) {
                let vm = this;
                return resources.filter(resource => vm.matchesAny(resource.data[attribute], searchArray));
            },
            clearFilters() {
                let vm = this;
                vm.schedulerConfig.eventStore.clearFilters();
                vm.schedulerConfig.resourceStore.clearFilters();
            },
            matchesAnyStartDates(date1, date2) {
                let fordate1 = moment(date1)
                let fordate2 = moment(date2)
                return fordate1.isSameOrAfter(fordate2, 'day')
            },
            matchesAnyEndDates(date1, date2) {
                let fordate1 = moment(date1)
                let fordate2 = moment(date2)
                return fordate1.isSameOrBefore(fordate2, 'day')
            },
            matchStartDate(date1, date2) {
                let fordate1 = moment(date1)
                let fordate2 = moment(date2)
                return fordate1.isSame(fordate2, 'day')
            },
            matchEndDate(date1, date2) {
                let fordate1 = moment(date1)
                let fordate2 = moment(date2)
                return fordate1.isSame(fordate2, 'day')
            },
            matchesAnySting(text, values) {
                // Check if the text matches any value in the array
                // return values.includes(value)
                if (!text && values.length) {
                    text = ""
                }
                return values.some(value => text.match(new RegExp(value, 'i')));
            },
            matchesAny(value, values) {

                return values.includes(value)
                // searcharr.some(value => text.match(new RegExp(value, 'i')));
            },
            panelCallback(data) {
                let vm = this;
                if (data && data.closeoutpanel) {
                    if (this.ShowBryntumCalendar) {
                        vm.schedulerConfig.element.classList['remove']('b-highlighting');
                    }
                    return
                }
                vm.isLoading = true;
                vm.infiniteScrollDirection = '';
                vm.latestResponseDirection = 'past';
                vm.dateRequestType = '';
                vm.recursiveCallCounter = 0;
                if (vm.ShowBryntumCalendar) {
                    vm.getBryntumSchedulerTapeChartData();
                } else {
                    vm.getTapeChartData();
                }
                // setTimeout(function () {
                      //  vm.getTapeChartData();
                // }, 7000);

                if (this.popupResObj) {
                    this.showUnAssignReservations(this.popupResObj);
                }
            },
            toggleResRateGrid() {
                this.showResGrid = this.showResGrid == "#" ? "$" : "#";
                this.reactGridInstance.update({ showResGrid: this.showResGrid == "#" ? true : false });
            },
            showUnAssignReservations(currResObj) {
                console.log("currResObj", currResObj);
                let vm = this;
                vm.popupResObj = currResObj;
                vm.$store.dispatch("dataRequestHandler", {
                    key: "GetTapeChartUnassignedReservations",
                    params: {
                        startDate: currResObj.StartDate ? moment(currResObj.StartDate).format("YYYY-MM-DD") : moment().format("YYYY-MM-DD"),
                        endDate: currResObj.EndDate ? moment(currResObj.EndDate).add(-1, 'days').format("YYYY-MM-DD") : moment().add(90, 'days').format("YYYY-MM-DD"),
                        propertyId: currResObj.PropertyId,
                        unitId: currResObj.UnitId,
                        UnitClassId: currResObj.UnitClassId,
                        // ratePlanId: 
                    },
                    callback: function (err, response) {
                        if (err) {
                            console.log("err in GetCalendarViewData", err);
                            return
                        }
                        if (response) {
                            if (response.errorMessage) {
                                vm.$store.dispatch("toastr", {
                                    type: "error",
                                    header: "CalendarView",
                                    message: response.errorMessage
                                });
                                return;
                            }

                            vm.reactUnassignedGridInstance.init({
                                _data: response.reservations,
                                _dateHeaders: response.dates,
                                _ratesCount: response.ratesCount,
                                _units: response.units,
                                _properties: response.properties,
                                _events: {
                                    navigateToReservation: vm.navigateToReservation,
                                    showUnAssignReservations: vm.showUnAssignReservations
                                }
                            });

                            vm.isModalVisible = true;
                        }

                    }
                })
            },
            close() {
                this.isModalVisible = false;
                this.popupResObj = null
            },
            yesButtonCallback() {

            },
            noCallback() {

            },
            dynamicSort(property) {
                var sortOrder = 1;
                if (property[0] === "-") {
                    sortOrder = -1;
                    property = property.substr(1);
                }
                return function (a, b) {
                    var result = (a[property] < b[property]) ? -1 : (a[property] > b[property]) ? 1 : 0;
                    return result * sortOrder;
                }
            },
            showLoading() {
                this.isPartialLoading = !this.isPartialLoading;
            },
            showClouseOutBtn() {
                let vm = this;
                let RatePlanId = vm.ratePlanList.filter(
                    obj => obj.id == vm.myValue
                );
                this.clouseOutGrid = true;
                this.rateGrid = false;
                this.restrictionsGrid = false;
                if (this.ShowBryntumCalendar) {
                    console.log("vm.schedulerConfig.element.classList =", vm.schedulerConfig.element.classList)
                    vm.schedulerConfig.eventStore.forEach(event => {
                        const taskClassList = new DomClassList(event.cls);
                        taskClassList.remove('b-match');
                        delete taskClassList['b-match']
                        console.log("taskClassList = ", taskClassList)
                    })
                    vm.schedulerConfig.element.classList['remove']('b-highlighting');
                    vm.schedulerConfig.element.classList['add']('b-highlighting');

                    // vm.schedulerConfig.element.classList[this.clouseOutGrid ? 'add' : 'remove']('b-highlighting');
                }

                this.$store.state.bus.$emit("setInvPannelValues", { filterObj: this.filterObj, ratePlanId: Number(RatePlanId[0].RatePlanId) });
            },
            showRateBtn() {
                this.clouseOutGrid = false;
                this.rateGrid = true;
                this.restrictionsGrid = false;
                if (this.clouseOutGrid && this.ShowBryntumCalendar) {
                    vm.schedulerConfig.element.classList[this.clouseOutGrid ? 'add' : 'remove']('b-highlighting');
                }
            },
            showrestrictionsBtn() {
                this.clouseOutGrid = false;
                this.rateGrid = false;
                this.restrictionsGrid = true;
                if (this.clouseOutGrid && this.ShowBryntumCalendar) {
                    vm.schedulerConfig.element.classList[this.clouseOutGrid ? 'add' : 'remove']('b-highlighting');
                }
            },
            hidesummaryPanel() {
                this.clouseOutGrid = false;
                this.rateGrid = false;
                this.restrictionsGrid = false;
                if (this.clouseOutGrid && this.ShowBryntumCalendar) {
                    vm.schedulerConfig.element.classList[this.clouseOutGrid ? 'add' : 'remove']('b-highlighting');
                }
                // this.getTapeChartData();
                // this.$store.state.bus.$emit('reset');

            },
            getSelectedRangePrice(resourceRecord,eventRecord) {
                let vm = this;
                let RatePlanId = vm.ratePlanList.filter(
                    obj => obj.id == vm.myValue
                );
                let obj = {
                    FolioId: null,
                    ReservationId: null,
                    UnitId: resourceRecord.data.UnitId,
                    PropertyId: resourceRecord.data.PropertyId,
                    StartDate: moment(eventRecord.data.startDate).format("YYYY-MM-DD"),
                    EndDate: moment(eventRecord.data.endDate).format("YYYY-MM-DD"),
                    NumOfAdults: null,
                    NumOfChildren: null,
                    Persons: 2,
                    RatePlanId: RatePlanId[0].RatePlanId
                };
                vm.$store.dispatch("dataRequestHandler", {
                    key: "GetFolioLedgerTransDetails",
                    params: obj,
                    callback: function (err, response) {
                        if (err) {
                            console.log(err);
                            return
                        }
                        else {
                            if (response) {
                                var selectedRangeDetails = {
                                    name : '$ '+response[0][0].Charges,
                                    otherName : '('+vm.formatFromNightlyCharges(response[0][0].Adr)+' ADR)',
                                    resourceId : resourceRecord.data.UnitId,
                                    cls : 'availableUnitPriceOverlay',
                                    eventColor : 'gray',
                                    eventStyle : 'border',
                                    resizable : false,
                                    startDate : moment(eventRecord.data.startDate).format("YYYY-MM-DD"),
                                    endDate :  moment(eventRecord.data.endDate).format("YYYY-MM-DD")
                                };
                                vm.schedulerConfig.eventStore.add(selectedRangeDetails);
                            }
                        }
                    }
                })
            },
        },
        computed: {
            fncIsEditInvPanel() {
                let vm = this;
                if (
                    vm.$store.state.userEntitlementList.hasOwnProperty(
                        "fncEditInvPanel"
                    )
                ) {
                    return vm.$store.state.userEntitlementList.hasOwnProperty(
                        "fncEditInvPanel"
                    )
                        ? vm.$store.state.userEntitlementList.fncEditInvPanel
                        : null;
                }
            },
        },
        mounted() {
            var vm = this;
            // window.addEventListener('storageChanged', () => {
            //     this.ShowBryntumCalendar = localStorage.getItem('ShowBryntumCalendar') == "true" ? true : false;
            //     if (this.ShowBryntumCalendar) {
            //         this.getTapeChartData();
            //     }
            // });
            this.$store.dispatch("GetUserEntitlementsAndDefaultProperty");
            this.GetUserEntitlementsAndDefaultProperty();
            this.reactGridInstance = new reactGrid(this.$refs.reactGridElem);
            this.reactUnassignedGridInstance = new unassignResGrid(this.$refs.unAssigneResList);
            this.getPropertiesBySearchText();
            this.GetUnitClasssListBySearchText();
            // this.getTapeChartData();
            this.getRatePlanDetailList();
            $(document).click(async function () {
                var parentElement = $('#betacalendarclsId');
                var childElements = parentElement.find('.input-group-addon');
                if (event && (event.target.id == "filterClickID" || event.target.parentElement && event.target.parentElement.id == "filterClickID")) {
                    if (vm.filterTooltipAction) {
                        // vm.schedulerConfig.resourceStore.filter(a => vm.filteredResources.some(b => a.data.id == b.data.id))
                        vm.schedulerConfig.resourceStore.filter(a => vm.filteredResources.some(b => {
                            return a.data.id == b.UnitId
                        }))
                        console.log("tooltip filter applied")
                        vm.filterTooltipAction = false;
                    } else {
                        vm.schedulerConfig.resourceStore.clearFilters();
                        vm.filterTooltipAction = true;
                        // calling filterpanelCallback function to get only filtered data from right panel
                        vm.isLoading = true;
                        vm.isFilteredApplied === true ? vm.filterpanelCallback(vm.panelFilterObj, "tapechartdata") : ''
                        console.log("tooltip filter removed")
                        setTimeout(function() {
                            vm.isLoading = false;
                        }, 1000);
                    }
                }
                if (event && (event.target.id == "searchClickID" || event.target.parentElement && event.target.parentElement.id == "searchClickID")) {
                    vm.openSearchPanel = !vm.openSearchPanel;
                    // vm.searchObj.StartDate = moment(vm.selectedStartDate).format("DD MMM YYYY");
                    // vm.searchObj.EndDate = moment(vm.selectedEndDate).format("DD MMM YYYY");
                    vm.searchObj = {
                        startDate: moment(vm.selectedStartDate).format("DD MMM YYYY"),
                        endDate: moment(vm.selectedEndDate).format("DD MMM YYYY"),
                        Adults: null,
                        Children: null,
                        Persons: vm.numberOfPersons,
                        RatePlanList: vm.ratePlanList,
                        RatePlanValue: vm.myValue,
                    }
                }
                if (event && (event.target.id == "addPersonButtonID" || event.target.parentElement && event.target.parentElement.id == "addPersonButtonID")) {
                    //alert("add person clicked")
                    vm.numberOfPersons = vm.numberOfPersons+1;
                    let nooffPersonsvalcls = document.getElementById("brynumberOfPersonsId")
                    nooffPersonsvalcls.innerHTML = vm.numberOfPersons
                    let eventsToRemove = [];
                    if(vm.schedulerConfig){
                        vm.schedulerConfig.eventStore.forEach(event => {
                            if(event.data.cls == "availableUnitPriceOverlay") {
                                eventsToRemove.push(event);
                            } 
                        });
                        vm.schedulerConfig.eventStore.remove(eventsToRemove);
                    }
                    vm.getAvailableUnitList();
                }
                if (event && (event.target.id == "subtractPersonButtonID" || event.target.parentElement && event.target.parentElement.id == "subtractPersonButtonID")) {
                    //alert("subtract person clicked")
                    if (vm.numberOfPersons > 1) {
                        vm.numberOfPersons = vm.numberOfPersons-1;
                        let nooffPersonsvalcls = document.getElementById("brynumberOfPersonsId")
                        nooffPersonsvalcls.innerHTML = vm.numberOfPersons
                        let eventsToRemove = [];
                        if(vm.schedulerConfig){
                            vm.schedulerConfig.eventStore.forEach(event => {
                                if(event.data.cls == "availableUnitPriceOverlay") {
                                    eventsToRemove.push(event);
                                } 
                            });
                            vm.schedulerConfig.eventStore.remove(eventsToRemove);
                        }
                        vm.getAvailableUnitList();
                    }
                    //vm.numberOfPersons == 0
                }
                // if (event && (event.target.id == "closePopupActionID" || event.target.parentElement && event.target.parentElement.id == "closePopupActionID")) {
                //     vm.popup.close();
                // }
                if (event && (event.target.id == "closeActionID" || event.target.parentElement && event.target.parentElement.id == "closeActionID")) {
                    // $(".b-theme-stockholm")[0].innerHTML = "";
                    let eventsToRemove = [];
                    vm.schedulerConfig.eventStore.forEach(event => {
                        if(event.data.cls == "availableUnitPriceOverlay" || event.data.cls.includes("availableUnitPriceOverlay")) {
                            eventsToRemove.push(event);
                        }
                    });
                    vm.schedulerConfig.eventStore.remove(eventsToRemove);
                    vm.schedulerConfig.features.timeSelection.selectedTimeSpan = null;
                    vm.schedulerConfig.resourceStore.clearFilters();
                    vm.isLoading = true;
                    vm.isFilteredApplied === true ? vm.filterpanelCallback(vm.panelFilterObj, "tapechartdata") : ''
                    console.log("tooltip Closed")
                    setTimeout(function() {
                        vm.isLoading = false;
                    }, 1000);
                }
                childElements.each(function () {
                    var classAttribute = $(this).attr('class');
                    var classList = classAttribute.split(' ');
                    console.log(classList);
                    if (classList.includes("active")) {
                        parentElement.addClass("showcalendarcls")
                    } else {
                        parentElement.removeClass("showcalendarcls")
                    }
                });
            })
            
        },
        watch: {
            searchTag(newValue, oldValue) {
                let vm = this;
                vm.getRatePlanDetailList("", newValue)
            },
            filterSearchPropertyText(searchText) {
                if (searchText)
                    this.getPropertiesBySearchText(searchText);
            },

            'filterObj.propertyId'(value) {
                this.GetUnitClasssListBySearchText();
            }

        },
        destroyed() {
            this.schedulerConfig.features.timeSelection.selectedTimeSpan = null; // closing selected date range and tooltip
            this.reactGridInstance.destroy();
            this.reactGridInstance = null;

            this.reactUnassignedGridInstance.destroy();
            this.reactUnassignedGridInstance = null;
        }
    };

</script>


<style>
    .modal-backdrop {
        position: fixed;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        background-color: rgba(0, 0, 0, 0.3);
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .modal {
        background: #FFFFFF;
        box-shadow: 2px 2px 20px 1px;
        overflow-x: auto;
        display: flex;
        flex-direction: column;
    }

    .modal-header,
    .modal-footer {
        padding: 15px;
        display: flex;
    }

    .modal-header {
        border-bottom: 1px solid #eeeeee;
        color: #4AAE9B;
        justify-content: space-between;
    }

    .modal-footer {
        border-top: 1px solid #eeeeee;
        justify-content: flex-end;
    }

    .modal-body {
        position: relative;
        padding: 20px 10px;
    }

    .btn-close {
        border: none;
        font-size: 20px;
        padding: 12px 20px !important;
        cursor: pointer;
        font-weight: bold;
        color: #4AAE9B;
        background: transparent;
        height: unset !important;
    }

    .btn-green {
        color: white;
        background: #4AAE9B;
        border: 1px solid #4AAE9B;
        border-radius: 2px;
    }
    table.b-grid-group-summary {
        display: none !important;
    }
    .b-grid-cell.b-resourcecollapse-cell.b-grid-cell-align-center.b-group-title {
            width: 100% !important;
    }
    .row-expanded.b-sch-resourcetimerange > div {
        height: 100% !important;
        align-items: normal !important;
    }
    .b-sch-resourcetimerange{
        display: inline-block !important;
    }
    .second.unassgined-reservation.statusType.nameOverflow.Reserved.sourceName.Tempo.unassigned.resIndex0.hotelModeUnassignedUnitRow.b-sch-dirty-new.b-sch-dirty.b-sch-event.b-sch-event-resizable-false {
        margin-bottom: 10px !important;
    }
    .second.unassgined-reservation.statusType.nameOverflow.Reserved.sourceName.Tempo.assigned.resIndex0.hotelModeUnassignedUnitRow.b-sch-dirty-new.b-sch-dirty.b-sch-event.b-sch-event-resizable-false {
        margin-bottom: 10px !important;
    }
    .second.unassgined-reservation.statusType.nameOverflow.Guaranteed.sourceName.Tempo.unassigned.resIndex0.hotelModeUnassignedUnitRow.b-sch-dirty-new.b-sch-dirty.b-sch-event.b-sch-event-resizable-false {
        margin-bottom: 10px !important;
    }
    .second.unassgined-reservation.statusType.nameOverflow.Confirmed.sourceName.Tempo.unassigned.resIndex0.hotelModeUnassignedUnitRow.b-sch-dirty-new.b-sch-dirty.b-sch-event.b-sch-event-resizable-false {
        margin-bottom: 10px !important;
    }
</style>

<style lang="scss">
    @import 'bryntumScheduler.scss';
    @import 'bryntumScheduler.css';
</style>